export default {
    title: '3Dissect',
    WEBSERVER: 'https://www.3dissect.com/',
    WEBSERVICE_URL: 'https://www.3dissect.com/wsthreeDissect/public_html/index.php/',
    //WEBSERVER: 'https://biotk.unad.edu.co/3dissect/',
    //WEBSERVICE_URL: 'https://biotk.unad.edu.co/3dissect/ws/public_html/index.php/',
}